import React from "react";
import Card from 'react-bootstrap/Card';
import Redirect from '../../../assets/images/redirect.png';
import RedirectOk from '../../../assets/images/redirectOk.png';

import './styles.css';
import PortChecker from "../components/PortChecker";

const Portas = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">                    
                    <Card className="card">
                        <Card.Title><h1>Redirecionamento de portas</h1></Card.Title>
                        <Card.Body>
                            <div>
                                <span>
                                    Imagine que você tem um roteador conectado à internet e uma rede local com vários dispositivos. Cada dispositivo possui um endereço IP interno único na rede, como 192.168.10.150, 192.168.10.10, 192.168.10.95 etc.
                                    
                                    Quando uma solicitação de conexão chega ao seu roteador(ONU) pela internet, ela contém um endereço IP de origem e um número de porta. Vamos supor que alguém esteja tentando acessar o seu servidor web a partir de fora da sua rede local. Essa pessoa envia uma solicitação ao endereço IP público do seu roteador na porta 80, que é a porta padrão para conexões HTTP.
                                </span>
                            </div>
                            
                            <div className='image'><img src={Redirect} alt="Foto" /></div>
                            <div>
                            <h5>Aqui está o passo a passo do que acontece com a solicitação de conexão:</h5>
                            <ul>
                                <li>A solicitação chega ao roteador(ONU) na interface WAN na porta 3389, que é a porta designada para serviços Área de Trabalho Remota.</li>
                                <li>O roteador verifica as regras de redirecionamento de portas que foram configuradas.</li>
                                <li>Se houver uma regra de redirecionamento para a porta 3389, o roteador(ONU) encaminha a solicitação para o endereço IP interno(LAN) especificado na configuração.</li>
                                <li>O dispositivo com o endereço IP interno correspondente (por exemplo, o seu servidor web) recebe a solicitação e responde ao remetente, estabelecendo uma conexão.</li>
                                <li>O roteador encaminha a resposta de volta ao remetente original através da rede.</li>
                            </ul>
                            </div>
                            <div className='image'><img src={RedirectOk} alt="Foto" />                              
                            </div>
                            <div>                                
                            <span>
                                Esse processo permite que você acesse serviços ou dispositivos internos de sua rede local a partir da internet. O roteador atua como um intermediário, direcionando as solicitações externas para os dispositivos corretos dentro da sua rede.
                            </span>
                            </div>
                            
                            <PortChecker />
                        </Card.Body>
                    </Card>
                    
                </div>
            </div>
        </div>
    )
};
export default Portas;